var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYallafelsekka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.465,
    height: 120.751,
    viewBox: "0 0 171.465 120.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M0,171.465H120.752V0H0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M0,171.465H120.752V0H0Z",
    fill: "#dddb00"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1209",
    "data-name": "Groupe 1209",
    transform: "translate(171.465) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_676",
    "data-name": "Groupe 676",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_675",
    "data-name": "Groupe 675",
    transform: "translate(29.487 47.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M19.183,24.11l-4.595-1.06a2.563,2.563,0,0,1-1.919-2.364V2.924L0,0V21.113c0,6.2,5.031,12.394,11.233,13.824l11.3,2.612c6.2,1.43,11.234-2.436,11.234-8.639V19.553a1.476,1.476,0,0,1,1.917-1.475l4.595,1.06A2.563,2.563,0,0,1,42.2,21.5V42.088L54.87,45.012V21.07c0-6.2-5.028-12.392-11.233-13.825l-11.3-2.609C26.131,3.2,21.1,7.07,21.1,13.274v9.36a1.479,1.479,0,0,1-1.92,1.476",
    fill: "#fff",
    style: {
      fill: "#04abec"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_677",
    "data-name": "Groupe 677",
    transform: "translate(29.648 119.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M0,14.023,19.753,30.276v.576L0,37.985V52.078l.963.226,31.25-12.529L54.868,45V32.338L32.214,27.107,1.083.251,0,0,0,0Z",
    fill: "#fff",
    style: {
      fill: "#04abec"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_678",
    "data-name": "Groupe 678",
    transform: "translate(29.647 82.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M12.668,2.924,0,0V35.113l0,0,12.664,2.924,42.2,9.742V35.113l-21.1-4.872V8.995L21.1,6.071V27.318L12.668,25.37Z",
    fill: "#fff",
    style: {
      fill: "#04abec"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_682",
    "data-name": "Groupe 682",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_679",
    "data-name": "Groupe 679",
    transform: "translate(64.195 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M12.851,28.279A15.427,15.427,0,1,0,28.278,12.851,15.444,15.444,0,0,0,12.851,28.279m43.706,0A28.278,28.278,0,1,1,28.278,0,28.311,28.311,0,0,1,56.556,28.279",
    fill: "#dddb00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_680",
    "data-name": "Groupe 680",
    transform: "translate(0 53.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M18,2.348A11.157,11.157,0,1,1,2.348,4.311,11.156,11.156,0,0,1,18,2.348",
    fill: "#dddb00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_681",
    "data-name": "Groupe 681",
    transform: "translate(92.473 107.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M28.278,28.278A28.311,28.311,0,0,1,0,56.557V43.706A15.444,15.444,0,0,0,15.427,28.278,15.444,15.444,0,0,0,0,12.851V0A28.311,28.311,0,0,1,28.278,28.278",
    fill: "#dddb00"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYallafelsekka);
export default __webpack_public_path__ + "static/media/yallafelsekka.ab138c2bb0f836846c03f6c9129e0b6d.svg";
export { ForwardRef as ReactComponent };